import { Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { GarbageStorageKeyInfoResponse } from "@/hooks/useGarbageCheck"
import { useTranslation } from "@/hooks/useTranslation"
import { theme } from "@/theme"

const EmptyState = styled.div`
    display: grid;
    place-items: center;
    min-height: 64px;
    padding: 12px;
    border: 1px dashed ${theme.palette.intentions.cleanerGray.main};
    border-radius: 8px;
    background-color: ${theme.palette.intentions.cleanerBackground.main};
    color: ${theme.palette.intentions.cleanerGray.dark};
    font-size: 13px;
    text-align: center;
`

const Label = styled.span`
    font-size: 12px;
    font-weight: bold;
    color: ${theme.palette.intentions.cleanerGray.dark};
`

/**
 * ゴミストッカーの鍵情報表示。タイトルは呼び出し側のカードが持つ。
 * 民泊用ゴミ捨て場の南京錠（RoomGarbageInfo）とは別物なので流用せず別表示。
 */
export const GarbageStorageKeyInfo = ({
    keyInfo
}: {
    keyInfo?: GarbageStorageKeyInfoResponse
}) => {
    const { t } = useTranslation()

    if (!keyInfo) {
        return <EmptyState>{t("鍵情報は登録されていません")}</EmptyState>
    }

    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                gap: 12px;
            `}
        >
            {/* 値が入っている項目のみ表示する（空項目を "-" で並べて誤解させない） */}
            {keyInfo.location && (
                <Row label={t("設置場所")} value={keyInfo.location} />
            )}
            {keyInfo.howToUnlock && (
                <Row label={t("解錠方法")} value={keyInfo.howToUnlock} />
            )}
            {keyInfo.unlockNumber && (
                <Row label={t("解錠番号")} value={keyInfo.unlockNumber} />
            )}
        </div>
    )
}

const Row = ({ label, value }: { label: string; value: string }) => (
    <div
        css={css`
            display: flex;
            flex-direction: column;
            gap: 2px;
        `}
    >
        <Label>{label}</Label>
        <Typography>{value}</Typography>
    </div>
)
